export default {
  fields: {
    caterer_id: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    },
  },
  relationships: {
    caterer: 'caterers',
    photos: 'photos',
    story_tags: 'story_tags'
  }
}
